/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { GetDeterminedAvailabilityFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { GetDeterminedAvailabilityFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';
import type { getDeterminedAvailability } from '.';

export const getDeterminedAvailabilityDataMock: GetDeterminedAvailabilityFragmentFragment = {
  state: 'AVAILABLE',
};

export const getDeterminedAvailabilityReturnMock: ReturnType<typeof getDeterminedAvailability> =
  '2';

export function getGetDeterminedAvailabilityFragmentedData(
  data?: GetDeterminedAvailabilityFragmentFragment,
) {
  return makeFragmentData(
    data || getDeterminedAvailabilityDataMock,
    GetDeterminedAvailabilityFragmentFragmentDoc,
  );
}
